import { Link } from 'react-router-dom';
import { siteInfo, stats } from '@/mocks/home';

export default function Hero() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20elegant%20minimalist%20composition%20with%20organized%20grid%20patterns%20and%20flowing%20data%20visualization%20elements%2C%20warm%20amber%20and%20cream%20tones%20with%20subtle%20coral%20highlights%2C%20digital%20archive%20or%20catalog%20system%20aesthetic%2C%20soft%20geometric%20shapes%20overlapping%20with%20organic%20curves%2C%20clean%20editorial%20photography%20quality%20with%20diffused%20warm%20lighting%2C%20harmonious%20balanced%20composition%20with%20Japanese%20design%20influence%2C%20sophisticated%20and%20refined%20atmosphere&width=1600&height=900&seq=fh-hero-bg&orientation=landscape"
        alt="番号大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <p className="text-background-50/80 text-sm md:text-base font-medium tracking-wider mb-4">
            海量番号 · 多维检索 · 即时更新
          </p>
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-4 leading-tight">
            {siteInfo.name}
          </h1>
          <p className="text-background-50/70 text-base md:text-lg mb-8 max-w-xl mx-auto leading-relaxed">
            {siteInfo.tagline}。收录 52,800+ 番号信息，提供按类型、演员、厂牌等多维度分类检索服务
          </p>

          <div className="relative max-w-lg mx-auto mb-10">
            <i className="ri-search-line absolute left-4 top-1/2 -translate-y-1/2 text-foreground-400 text-lg"></i>
            <input
              type="text"
              placeholder="输入番号、演员名称或厂牌搜索..."
              className="w-full pl-12 pr-5 py-3.5 rounded-2xl bg-background-50/95 backdrop-blur-sm border border-background-200/50 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200/50 transition-all"
            />
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-2xl mx-auto">
            {stats.map((stat) => (
              <div key={stat.label} className="bg-background-50/10 backdrop-blur-sm rounded-xl px-4 py-3 text-center border border-background-50/10">
                <div className="w-7 h-7 mx-auto mb-1.5 flex items-center justify-center">
                  <i className={`${stat.icon} text-primary-400 text-lg`}></i>
                </div>
                <div className="text-xl md:text-2xl font-bold text-background-50 font-heading">{stat.value}</div>
                <div className="text-xs text-background-50/60 mt-0.5">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-s-line text-background-50/50 text-2xl"></i>
      </div>
    </section>
  );
}